import classNames from "classnames";
import React, { PropsWithChildren, ReactElement } from "react";
import { withDefault } from "../utils/withDefault";

export interface Props
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  color?: "primary" | "success" | "danger" | "black" | "white" | "warning";
  variant?: "filled" | "outline" | "soft";
  uppercase: boolean;
}

export function Label(props: PropsWithChildren<Props>): ReactElement {
  const { children, ...rest } = props;
  return (
    <div
      data-color={withDefault(rest.color, "white")}
      data-variant={withDefault(rest.variant, "filled")}
      className={classNames("Label", rest.className)}
      style={{
        textTransform: rest.uppercase ? "uppercase" : "none",
      }}
    >
      {children}
    </div>
  );
}

export default Label;
